import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';
import { useParams } from 'react-router-dom';

const CurrencyInput = () => {
  const { currencyId = '' } = useParams();
  const decodedId = currencyId ? atob(currencyId) : currencyId;
  const id = decodedId.replace(/\D/g, ''); 
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const [currencies, setCurrencies] = useState([]);
  const route = 'generalCurrency';

  useEffect(() => {
    if (currencyId) {
      setIsEditing(true);
      fetchCurrencyDetails();
    }
    fetchCurrencies();
  }, [currencyId]);

  const fetchCurrencyDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.currency}${id}/`, { headers });
      const currencyDetails = response.data;

      setFormData(currencyDetails);
    } catch (error) {
      console.error('Error fetching currency details:', error);
    }
  };

  const fetchCurrencies = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.currency}`, { headers });
      const currencies = response.data;

      const currencyOptions = currencies.map(currency => ({
        value: currency.id,
        label: currency.name,
      }));

      setCurrencies(currencyOptions);
    } catch (error) {
      console.error('Error fetching currencies:', error);
    }
  };

  const handleFormSubmitSuccess = (response) => {
    // Handle form submission success
  };

  const currencyFields = [
    {
      name: 'code',
      label: 'Currency Code',
      type: 'select',
      options: [
        { value: 'USD', label: 'US Dollar' },
        { value: 'EUR', label: 'Euro' },
        { value: 'GBP', label: 'British Pound' },
        { value: 'KES', label: 'Kenyan Shilling' },
        { value: 'INR', label: 'Indian Rupee' },
        { value: 'JPY', label: 'Japanese Yen' },
      ],
    },
    {
      name: 'name',
      label: 'Name',
      type: 'text',
    },
    {
      name: 'symbol',
      label: 'Symbol',
      type: 'text',
    },
    {
      name: 'decimal_places',
      label: 'Decimal Places',
      type: 'number',
    },
    {
      name: 'exchange_rate',
      label: 'Exchange Rate',
      type: 'number',
    },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Currency' : 'Create Currency'}</h1>
      <FormComponent
        fields={currencyFields}
        initialFormData={formData}
        route={route}
        onSubmitSuccess={handleFormSubmitSuccess}
        onSubmitError={() => {}}
      />
    </div>
  );
};

export default CurrencyInput;